import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
    const token = localStorage.getItem('access_token');
    const activeWorkspaceId = localStorage.getItem('active_workspace_id');
    const headers: Record<string, string> = {};

    if (token) {
        headers['Authorization'] = `Bearer ${token}`;
    }

    if (activeWorkspaceId) {
        headers['X-Acting-User-Id'] = activeWorkspaceId;
    }

    if (Object.keys(headers).length > 0) {
        req = req.clone({
            setHeaders: headers
        });
    }

    return next(req);
};
